export const environment = {
  production: false,
  backendUrl: 'https://ws-vehicles-dev.dekra.com/costtool',
  costToolUrl: 'https://bau-sv-kosten-dev.dekra.de',
  reportGeneratorUrl: 'https://bau-sv-bericht-dev.dekra.de',
};
